import Vue from "vue";
import Router from "vue-router";
import Home from "./views/home";
import About from "./views/about";
import Product from "./views/index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        {
          path: "/page/:PName",
          name: "product",
          component: Product
        }
      ]
    },
    {
      path: "/about",
      name: "about",
      component: About
    }
  ]
});
